import { TServiceClientInitialState } from '../types';

export const DEFAULT_SERVICE_CLIENT_STATE: TServiceClientInitialState = {
    clients: null,
    client: null,
    total: 0,
    loading: false,
    error: null,
    success: null,
};
